/**
 * Web no-op stubs for the RevenueCat integration.
 *
 * Metro resolves this file (`.web.ts`) on web, so the web bundle never imports
 * `react-native-purchases` (no web support). On web, purchasing keeps using the
 * existing WordPress `/join/` redirect — these stubs just keep the API shape so
 * shared code can import from `lib/purchases/RevenueCat` unconditionally.
 *
 * Keep this in sync with the native `RevenueCat.ts` exports.
 */
import type {
  CustomerInfo,
  PurchasesOffering,
  PurchasesPackage,
} from 'react-native-purchases';

export const ENTITLEMENTS = {
  membership: 'membership',
} as const;

export function configureRevenueCat(): void {}

export async function identifyRevenueCatUser(
  _appUserId: string,
  _email?: string | null,
  _displayName?: string | null,
): Promise<void> {}

export async function resetRevenueCatUser(): Promise<void> {}

export async function getCurrentOffering(): Promise<PurchasesOffering | null> {
  return null;
}

export async function getOfferingById(
  _identifier: string,
): Promise<PurchasesOffering | null> {
  return null;
}

export function packagesFromOffering(
  offering: PurchasesOffering | null,
): PurchasesPackage[] {
  return offering?.availablePackages ?? [];
}

export function grantAllPlanFamily(_productId: string): 'normal' | 'pro' | null {
  return null;
}

export async function purchasePackage(
  _pkg: PurchasesPackage,
): Promise<CustomerInfo | null> {
  return null;
}

export async function restorePurchases(): Promise<CustomerInfo | null> {
  return null;
}

export async function getCustomerInfo(): Promise<CustomerInfo | null> {
  return null;
}

export async function refreshCustomerInfo(): Promise<CustomerInfo | null> {
  return null;
}

export function addCustomerInfoListener(
  _listener: (info: CustomerInfo) => void,
): () => void {
  return () => {};
}

export function hasActiveEntitlement(
  _info: CustomerInfo | null,
  _entitlementId?: string,
): boolean {
  return false;
}

export function isPurchasesAvailable(): boolean {
  return false;
}

export function getActiveMembershipEntitlement(
  _info: CustomerInfo | null,
): CustomerInfo['entitlements']['active'][string] | null {
  return null;
}

export function getManagementUrl(_info: CustomerInfo | null): string {
  return 'https://apps.apple.com/account/subscriptions';
}

export async function getTrialEligibility(
  _productIds: string[],
): Promise<Record<string, boolean>> {
  return {};
}
